export class ControlConditionModel {
  conditionColName: string;
  conditionColSymbol: string;
  conditionColText: any;

  constructor(item?: ControlConditionModel) {
    this.conditionColName = item?.conditionColName;
    this.conditionColSymbol = item?.conditionColSymbol;
    this.conditionColText = item?.conditionColText;
  }
}
